import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <div className="navbar-logo">
            <Link to="/">
              <div className="logo-text">Evidencer Record Query</div>
            </Link>
          </div>
          
          {/* Hamburger menu for mobile */}
          <div className="hamburger-menu" onClick={toggleMobileMenu}>
            <div className={`hamburger-icon ${mobileMenuOpen ? 'open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          
          {/* Two-row navigation for desktop and mobile dropdown */}
          <div className={`navbar-links-container ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <div className="navbar-links-row primary-links">
              <Link to="/" className="navbar-link">Home</Link>
              <Link to="/#query" className="navbar-link special">
                <span className="special-icon"></span>
                Record Query
              </Link>
              <Link to="/documentation" className="navbar-link">
                Documentation
              </Link>
              <a href="https://encrypted-query.evidencer.io/" className="navbar-link" target="_blank" rel="noopener noreferrer">
                Encrypted Query
              </a>
            </div>
            
            <div className="navbar-links-row secondary-links">
              <a href="https://hero.evidencer.io/user-guide" className="navbar-link">
                User Guide
              </a>
              <a href="https://www.evidencer.io/" className="navbar-link highlight-link">
                Legal Resources
              </a>
              <a href="https://evidencer.freeweb3.com" className="navbar-link" target="_blank" rel="noopener noreferrer">
                Evidencer Portal
              </a>
              <a href="https://www.evidencer.io/" className="navbar-link" target="_blank" rel="noopener noreferrer">
                LexAutomatico
              </a>
              <a href="https://hero.evidencer.io/" className="navbar-link" target="_blank" rel="noopener noreferrer">
                Web3 Legal Tools
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;